/*
 * PARCOURS DE LA FICHE (25/10/2026, Maïwenn, d'après les enregistrements Clarity des visites pub)
 *
 * 1. Zoom photo : le bouton Retour du téléphone ferme le zoom au lieu de ramener sur Google.
 *    Le zoom n'ajoutait rien à l'historique ; 3 visites sur 14 regardées finissaient dedans.
 * 2. Fenêtre « 10 % offerts » (Shopify Forms) : plus jamais après un ajout au panier, jusqu'à la
 *    fin de la visite. Elle s'ouvrait par-dessus le panier juste après l'ajout.
 */
(function () {
  var CLE = 'lbm-ajout-panier';

  function sansPopup(memoriser) {
    document.documentElement.classList.add('lbm-sans-popup');
    if (memoriser) {
      try { sessionStorage.setItem(CLE, '1'); } catch (e) {}
    }
  }

  try { if (sessionStorage.getItem(CLE)) sansPopup(false); } catch (e) {}

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.closest && e.target.closest('product-form, form[action*="/cart/add"]')) sansPopup(true);
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('button[name="add"]')) sansPopup(true);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { sansPopup(true); });
    }
    document.querySelectorAll('product-modal').forEach(function (modal) {
      new MutationObserver(function () {
        var etat = history.state || {};
        if (modal.hasAttribute('open')) {
          if (!etat.lbmZoom) history.pushState(Object.assign({}, etat, { lbmZoom: true }), '');
        } else if (etat.lbmZoom) {
          history.back();
        }
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  });

  window.addEventListener('popstate', function () {
    var ouvert = document.querySelector('product-modal[open]');
    if (ouvert && typeof ouvert.hide === 'function') ouvert.hide();
  });
})();
